export class SearchResultCell {
    private _value;
    private _Id;
    constructor(value: string, id: number){
        this._value = value;
        this._Id = id;
    }
}